import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phuluchangkhong from "components/Tonghopvantai/Phuluchangkhong.js";
export default function PhuluchangkhongTH() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Phụ lục hàng không",
            tabContent: <Phuluchangkhong />,
          },
        ]}
      />
    </div>
  );
}
